export const activity = {
screenTitle: "Actividad",
badgeContractor: "Espacio de contratista",
segmentInbox: "Notificaciones",
segmentFeed: "Actividad del espacio de trabajo",
notifications: "Notificaciones",
notificationFallback: "Notificación",
recentUpdates: "Actualizaciones recientes",
fullFeed: "Feed completo",
pendingApproval: "Necesita tu respuesta",
reviewRequired: "Revisión requerida",
inspectionReportMeta: "Informe de inspección",
viewAsset: "Ver activo",
approvedForRepair: "Aprobado para reparación",
repairsApproved_one: "{{count}} reparación aprobada",
repairsApproved_other: "{{count}} reparaciones aprobadas",
createJobs: "Crear trabajos",
awaitingRecipient: "Esperando al destinatario",
firstShared: "Primera vez compartido {{date}}",
resent: "Reenviado {{date}}",
waitingForReview: "Esperando revisión",
resendDeadline: "Reenviar y actualizar plazo",
jobInvitations: "Invitaciones a trabajos",
jobFallbackTitle: "Trabajo #{{id}}",
acceptOrDecline: "Aceptar o rechazar",
accept: "Aceptar",
decline: "Rechazar",
reportsSharedWithYou: "Informes compartidos contigo",
inspectionReportCard: "Informe de inspección",
emptyInboxTitle: "Nada requiere tu atención",
emptyInboxSub: "Aquí aparecen las aprobaciones, invitaciones y respuestas que están pendientes de ti.",
feedTitle: "Feed de actividad",
emptyFeedTitle: "Sin actividad aún",
emptyFeedSub: "Las asignaciones, cambios de estado y aprobaciones aparecerán aquí.",
events: {
  inspectionSentBack: "Inspección devuelta",
jobAssigned: "Trabajo asignado",
jobAssignedTo: "Trabajo asignado a {{name}}",
jobAccepted: "Trabajo aceptado",
jobRejected: "Trabajo rechazado",
jobRejectedBy: "Trabajo rechazado por {{name}}",
jobStarted: "Trabajo iniciado",
jobScheduled: "Trabajo programado",
jobReportShared: "Informe de trabajo compartido",
teamMemberJoined: "Se unió al equipo",
jobPaused: "Trabajo en pausa",
jobResumed: "Trabajo reanudado",
completionSubmitted: "Finalización enviada",
jobVerified: "Trabajo verificado",
reworkRequested: "Retrabajo solicitado",
reworkRequestedBy: "Retrabajo solicitado por {{name}}",
evidenceRequested: "Se han solicitado más pruebas",
evidenceRequestedBy: "{{name}} solicitó más pruebas",
jobStatusChanged: "Trabajo {{status}}",
jobUpdatedFallback: "actualizado",
contractorInvited: "Contratista invitado",
contractorAccepted: "El contratista aceptó la orden de trabajo",
contractorDeclined: "El contratista rechazó la orden de trabajo",
quoteRequestSent: "Solicitud de presupuesto enviada",
quoteSubmitted: "Presupuesto enviado",
quoteAccepted: "Presupuesto aceptado",
quoteRejected: "Presupuesto rechazado",
quoteDeclined: "Solicitud de presupuesto rechazada",
contractorAwarded: "Contratista adjudicado",
inspectionShared: "Inspección compartida",
inspectionCompleted: "Inspección completada",
inspectionApproved: "Inspección aprobada",
requestCreated: "Solicitud presentada",
requestApproved: "Solicitud aprobada",
requestDeclined: "Solicitud rechazada",
requestConverted: "Solicitud convertida en trabajo",
requestClosed: "Solicitud cerrada",
assetDecommissioned: "Activo fuera de servicio",
assetRetired: "Activo retirado definitivamente",
connectedAlert: "Alerta de dispositivo",
assetCreated: "Activo añadido",
assetUpdated: "Activo actualizado",
assetDeleted: "Activo eliminado",
assetInService: "Activo de nuevo en servicio",
contactAdded: "Contacto añadido",
contactSharedTeam: "Contacto compartido con el equipo",
contactPromoted: "Contacto promovido a cuenta",
contactInvited: "Contacto invitado",
contactLinked: "Contacto vinculado",
assetRelAdded: "Relación de activo añadida",
assetRelUpdated: "Relación de activo actualizada",
assetRelRemoved: "Relación de activo eliminada",
duplicateMarked: "Activo duplicado marcado",
canonicalSet: "Activo canónico definido",
duplicatesMerged: "Activos duplicados fusionados",
approvalWithAsset: "Inspección de {{asset}} aprobada por {{recipient}}",
approvalByRecipient: "Informe aprobado por {{recipient}}",
approvalGeneric: "Informe de inspección aprobado",
rejectionWithAsset: "Inspección de {{asset}} rechazada por {{recipient}}",
rejectionByRecipient: "Informe rechazado por {{recipient}}",
rejectionGeneric: "Informe de inspección rechazado",
},
jobStatus: {
draft: "Borrador",
open: "Abierto",
accepted: "Aceptado",
scheduled: "Programado",
inProgress: "En curso",
paused: "En pausa",
completed: "Completado",
verified: "Verificado",
rejected: "Rechazado",
cancelled: "Cancelado",
},
insights: {
  kpiName: {
    portfolio_condition: "Estado general",
    assets_good_condition: "Activos en buen estado",
    inspection_pass_rate: "Inspecciones superadas",
    first_time_fix: "Reparado a la primera",
    backlog_weeks: "Trabajo pendiente (semanas)",
    mttr: "Tiempo medio de reparación",
    maintenance_approval_turnaround: "Tiempo de aprobación",
    maintenance_reassignment_rate: "Trabajo reasignado",
    maintenance_reschedule_rate: "Mantenimiento reprogramado",
    maintenance_missed_rate: "Mantenimiento no realizado",
    maintenance_skip_rate: "Mantenimiento omitido",
    on_time_completion: "Terminado a tiempo",
    reactive_vs_planned: "Trabajo no planificado",
    pm_schedule_compliance: "Mantenimiento planificado a tiempo",
    cert_currency: "Certificados vigentes",
    statutory_compliance: "Cumplimiento legal",
  },
  kpiTarget: "Objetivo {{target}}",
  headlineKpi: {
    health: "Salud",
    riskLevel: "Nivel de riesgo",
    atRisk: "Activos en riesgo",
    outOfService: "Fuera de servicio",
    onTime: "A tiempo",
    compliance: "Cumplimiento",
    ofTotal: "de {{total}}",
    noCompletedJobsWithDueDates: "no hay órdenes completadas con fecha de vencimiento",
    nothingToProveYet: "aún no hay nada que acreditar",
    registerNotLoaded: "registro de cumplimiento no cargado",
  },
  kpiDetail: {
    requirementsCompliant_one: "{{compliant}} de {{count}} requisito cumplido",
    requirementsCompliant_many: "{{compliant}} de {{count}} de requisitos cumplidos",
    requirementsCompliant_other: "{{compliant}} de {{count}} requisitos cumplidos",
    certsCurrent: "Vigentes: {{valid}} de {{total}}",
    onSchedule: "{{completed}} de {{total}} según lo previsto",
    jobsReactive_one: "{{reactive}} de {{count}} orden de trabajo no planificada",
    jobsReactive_many: "{{reactive}} de {{count}} de órdenes de trabajo no planificadas",
    jobsReactive_other: "{{reactive}} de {{count}} órdenes de trabajo no planificadas",
    onTime: "{{onTime}} de {{total}} a tiempo",
    plannedOccurrences_one: "{{done}} de {{count}} ocurrencia planificada",
    plannedOccurrences_many: "{{done}} de {{count}} de ocurrencias planificadas",
    plannedOccurrences_other: "{{done}} de {{count}} ocurrencias planificadas",
    pastDueNoDecision: "{{missed}} de {{total}} vencidas sin decisión",
    movedWithDelay_one: "{{moved}} de {{total}}, {{count}} día de retraso medio",
    movedWithDelay_many: "{{moved}} de {{total}}, {{count}} de días de retraso medio",
    movedWithDelay_other: "{{moved}} de {{total}}, {{count}} días de retraso medio",
    moved: "Reprogramadas: {{moved}} de {{total}}",
    decidedWaiting: "Resueltas: {{decided}}, en espera: {{pending}}",
    decided: "Resueltas: {{decided}}",
    completedJobs_one: "{{count}} orden de trabajo completada",
    completedJobs_many: "{{count}} de órdenes de trabajo completadas",
    completedJobs_other: "{{count}} órdenes de trabajo completadas",
    noOpenJobs: "No hay órdenes de trabajo abiertas",
    noRecentCompletions: "No hay órdenes completadas recientemente para estimar el ritmo",
    openPerWeek: "Abiertas: {{open}} · {{rate}}/sem.",
    reopenedOf: "Reabiertas: {{reopened}} de {{total}}",
    itemsOf_one: "{{pass}} de {{count}} elemento",
    itemsOf_many: "{{pass}} de {{count}} de elementos",
    itemsOf_other: "{{pass}} de {{count}} elementos",
    postureCounts: "{{clear}} en buen estado · {{watch}} a vigilar · {{action}} con acción pendiente",
    atRiskOf: "{{atRisk}} de {{total}} en riesgo",
  },
  kpiUnit: {
    days: "{{value}} d",
    weeks: "{{value}} sem.",
  },
  kpiTargetValue: {
    reactive: "≤ 20 % no planificado",
    oneDay: "≤ 1 día",
    trendDown: "tendencia a la baja",
    trendUp: "tendencia al alza",
    underFourWeeks: "< 4 semanas",
    rework: "retrabajo ≤ 5 %",
  },
  forecast: {
    certificatesLapse_one: "{{count}} certificado vence en {{days}} días",
    certificatesLapse_many: "{{count}} de certificados vencen en {{days}} días",
    certificatesLapse_other: "{{count}} certificados vencen en {{days}} días",
    moreSuffix_one: "+{{count}} más",
    moreSuffix_many: "+{{count}} más",
    moreSuffix_other: "+{{count}} más",
    backlogStalled_one: "{{count}} orden de trabajo pendiente no se está resolviendo",
    backlogStalled_many: "{{count}} de órdenes de trabajo pendientes no se están resolviendo",
    backlogStalled_other: "{{count}} órdenes de trabajo pendientes no se están resolviendo",
    backlogStalledDetail: "No se completó ninguna orden de trabajo en las últimas 4 semanas: el trabajo pendiente seguirá creciendo si no se actúa.",
    backlogGrowing: "Se prevé que el trabajo pendiente llegue a ~{{projected}} en 4 semanas",
    backlogGrowingDetail: "Entran {{inflow}}/sem. frente a {{velocity}}/sem. resueltas: la capacidad está por debajo de la demanda.",
    backlogBurndown: "El trabajo pendiente se resolverá en ~{{weeks}} semanas al ritmo actual",
    backlogBurndownDetail: "Abiertas: {{open}} · se resuelven {{velocity}}/sem. frente a {{inflow}}/sem. que entran.",
    declineTitle: "Es probable que {{name}} pase pronto a «Acción»",
    declineDetailDocument: "Actualmente «Vigilar» ({{score}}/100); {{regulation}} vence en 30 días.",
    declineDetailSchedule: "Actualmente «Vigilar» ({{score}}/100) con una inspección programada vencida o pendiente.",
  },
  sections: {
    a11y: "Secciones de Analítica",
    workflows: "Flujos de trabajo",
    overview: "Resumen",
  },
chart: {
emptyReason: {
noRecords: "No hay registros disponibles",
noQualifyingRecords: "No hay registros que cumplan los criterios",
filteredEmpty: "No hay coincidencias para estos filtros",
insufficientSample: "Aún no hay pruebas suficientes",
notApplicable: "No aplicable",
loadFailed: "No se pudieron cargar los datos del gráfico",
stale: "Los datos necesitan actualizarse",
},
defaultAccessibilityLabel: "Gráfico",
},
shell: {
hideDetails: "Ocultar detalles de información",
showDetailsSuffix: "Mostrar detalles de información.",
expandHint: "Toca dos veces para expandir el panel de información completo",
},
conditionPortfolio: {
stableCount_one: "{{count}} estable.",
stableCount_many: "{{count}} estables.",
stableCount_other: "{{count}} estables.",
band: {
critical: "Crítico",
action_recommended: "Acción recomendada",
deteriorating: "En deterioro",
watch: "Vigilar",
stable: "Estable",
},
bandInfo: {
critical: "Activos cuya evidencia indica que necesitan atención ya: puntos de seguridad fallidos, trabajo urgente vencido o un deterioro rápido.",
action_recommended: "Activos que empeoran y para los que se aconseja una acción planificada antes de que sean críticos.",
deteriorating: "Activos cuyas inspecciones, reparaciones o historial de mantenimiento muestran un deterioro constante.",
watch: "Activos con una señal de alerta temprana que conviene vigilar, aún sin deterioro.",
},
noDominantDriver: "Ningún factor destaca.",
recurringFault_one: "{{count}} activo con una avería recurrente",
recurringFault_other: "{{count}} activos con una avería recurrente",
repeatRepairs: "{{count}} con reparaciones repetidas",
noExceptions: "No hay averías recurrentes ni reparaciones repetidas en toda la cartera.",
noteSuffix: "Las señales de los contadores se muestran en cada activo, no aquí.",
moreOnList: "+{{count}} más en la lista de activos.",
wholeCountsNote: "Los recuentos abarcan todos los activos, a fecha de {{date}}. Los activos listados son ejemplos de los cargados.",
recurringFault_many: "{{count}} activos con una avería recurrente",
},
panel: {
basedOn: "Basado en: {{source}}",
severityHighPriority: "Alta prioridad",
severityAttention: "Atención",
severityOnTrack: "Según lo previsto",
severityFyi: "Info",
severityNote: "Nota",
moreItems: "+{{count}} más aquí: refine o busque para acotar.",
signalsTitle: "Señales",
recommendedActionTitle: "Acción recomendada",
},
kpiInfo: {
aboutLabel: "Acerca de {{label}}",
hint: "Abre una explicación de esta métrica y cómo usarla.",
},
metricInfoSheet: {
dismissOverlay: "Descartar",
close: "Cerrar",
whatItMeasures: "LO QUE MIDE",
howToUseIt: "CÓMO USARLO",
basedOn: "BASADO EN",
asOf: "A fecha de · {{value}}",
target: "Objetivo · {{value}}",
},
priorityCard: {
feedbackHelpful: "Útil",
feedbackNotUseful: "No útil",
feedbackSnooze: "Posponer",
feedbackDismiss: "Descartar",
recommended: "Recomendado: {{action}}.",
effort: "Esfuerzo: {{value}}",
expectedBenefit: "Beneficio esperado: {{value}}",
dataGaps: "Lagunas de datos",
butAlso: "Pero también",
feedbackTrigger: "Comentarios sobre esta información",
feedbackSheetTitle: "¿Te ha resultado útil?",
},
journeys: {
tabExecutive: "Ejecutivo",
tabRequest: "Solicitud",
tabInspection: "Inspección",
tabJob: "Orden de trabajo",
tabAsset: "Activo",
tabContractor: "Contratista",
tabCompliance: "Cumplimiento",
tablistLabel: "Paneles de recorridos",
executiveAssistantTitle: "Asistente ejecutivo",
pageTitle: "Análisis de recorridos",
journeyCount_one: "{{count}} recorrido",
journeyCount_other: "{{count}} recorridos",
requestFunnel: "Embudo de solicitudes",
journeyFunnel: "Embudo de recorridos",
stageFlow: "Flujo de etapas",
noJourneyFlow: "Aún no hay flujo de recorridos.",
durationDistribution: "Distribución de la duración de los recorridos",
noCompletedJourneys: "Aún no hay recorridos completados.",
bottlenecksMedianGap: "Cuellos de botella (intervalo mediano entre etapas)",
bottleneckEmpty: "Aún no hay datos. Un cuello de botella necesita al menos un recorrido que haya completado dos pasos consecutivos (por ejemplo, solicitud → aprobación).",
workFunnel: "Embudo de trabajo",
bottleneckRanking: "Clasificación de cuellos de botella",
recentJourneyActivity: "Actividad reciente de los recorridos",
noRecentEvents: "No hay eventos recientes.",
slaComplianceByStage: "Cumplimiento del SLA por etapa",
slaEmpty: "Aún no hay datos. Esto se completa cuando se aprueba una solicitud, una inspección da lugar a una orden de trabajo, o una orden de trabajo se inicia o se completa; el cumplimiento del SLA mide los intervalos entre esos pasos.",
bottlenecks: "Cuellos de botella",
whatNeedsAttention: "Qué necesita atención",
journeyCount_many: "{{count}} recorridos",
},
screen: {
  aiSummaryButton: "Redactar un resumen con IA",
  emptyStartInspection: "Iniciar una inspección",
  emptyAddAsset: "Añadir un activo",
scopeAllMultiTeam: "Trabajo de todos: lo mejor para comparar equipos uno al lado del otro.",
scopeAllSingleTeam: "Todo el trabajo en tu cuenta.",
scopePersonalMultiTeam: "Solo tu trabajo. Cambie a Todos para ver todo el equipo.",
scopePersonalSingleTeam: "Solo tu trabajo.",
scopeTeamMultiTeam: "Solo se incluye {{team}}. Cambie el alcance a Todos para comparar equipos uno al lado del otro.",
scopeTeamSingleTeam: "Solo se incluye {{team}}.",
greetingLate: "Trabajando hasta tarde",
greetingMorning: "Buenos días",
greetingAfternoon: "Buenas tardes",
greetingEvening: "Buenas noches",
greetingNoPriorities: "Hoy no hay prioridades. Las tendencias aparecerán abajo a medida que haya más datos.",
greetingDanger_one: "{{count}} problema necesita atención hoy: el elemento principal es de alto riesgo.",
greetingDanger_other: "{{count}} problemas necesitan atención hoy: el elemento principal es de alto riesgo.",
greetingTechnician_one: "Tiene {{count}} tarea en cola. Empiece por la tarjeta superior.",
greetingTechnician_other: "Tiene {{count}} tareas en cola. Empiece por la tarjeta superior.",
greetingExecutive_one: "{{count}} elemento merece un vistazo; primero, el más costoso.",
greetingExecutive_other: "{{count}} elementos merecen un vistazo; primero, los más costosos.",
greetingTeam_one: "{{count}} prioridad para el equipo hoy.",
greetingTeam_other: "{{count}} prioridades para el equipo hoy.",
loadingTitle: "Cargando Analítica",
emptyGetsUsefulTitle: "Analítica se vuelve útil con el uso",
emptyGetsUsefulDescription: "Añada un activo o inicie una inspección. Analítica mostrará entonces lo que necesita atención y lo que se retrasa.",
partialDataCaption: "Estos gráficos utilizan registros cargados. Los totales de la cartera pueden estar incompletos.",
partialDataCaptionConditionWhole: "Estado, nivel de riesgo, en riesgo y fuera de servicio abarcan todos los activos. Las demás cifras y gráficos utilizan registros cargados y pueden estar incompletos.",
partialDataCaptionConditionBandsWhole: "Estado, nivel de riesgo, en riesgo, fuera de servicio, las bandas de condición y los activos en buen estado abarcan todos los activos. Las demás cifras y gráficos utilizan registros cargados y pueden estar incompletos.",
refreshErrorTitle: "Algunos datos de Analítica no se pudieron actualizar",
refreshErrorDescription: "Los gráficos siguientes usan registros en caché y pueden estar incompletos. Vuelve a intentarlo cuando tengas conexión.",
roleTechnician: "Técnico",
roleManager: "Gerente",
roleExecutive: "Ejecutivo",
switchToRoleView: "Cambiar a la vista {{role}}",
resetToAutoLabel: "Restablecer a la vista detectada automáticamente",
resetToAutoText: "Restablecer a automático",
showingLabel: "Mostrando",
clearSiteFilter: "Borrar filtro de sitio",
allSites: "Todos los sitios",
unassignedSite: "Sin asignar",
selectedSiteFallback: "Sitio seleccionado",
standardsEyebrow: "Estándares",
operationalKpisTitle: "KPI operativos",
subtitleNeedAttention_one: "{{count}} necesita atención · {{onTrack}} en el objetivo",
subtitleNeedAttention_other: "{{count}} necesitan atención · {{onTrack}} en el objetivo",
subtitleAllOnTarget_one: "{{count}} KPI cumple el objetivo",
subtitleAllOnTarget_many: "Los {{count}} KPI cumplen el objetivo",
subtitleAllOnTarget_other: "Los {{count}} KPI cumplen el objetivo",
asOfSuffix: "a fecha de {{time}}",
kpiAllClearAccessibilityLabel_one: "{{count}} KPI cumple el objetivo. Mostrar todo.",
kpiAllClearAccessibilityLabel_many: "Los {{count}} KPI cumplen el objetivo. Mostrar todo.",
kpiAllClearAccessibilityLabel_other: "Los {{count}} KPI cumplen el objetivo. Mostrar todo.",
kpiAllClearText_one: "{{count}} KPI cumple el objetivo",
kpiAllClearText_many: "Los {{count}} KPI cumplen el objetivo",
kpiAllClearText_other: "Los {{count}} KPI cumplen el objetivo",
showAllLabel: "Mostrar todo",
hideOnTargetKpis: "Ocultar KPI que cumplen el objetivo",
showOnTargetKpis_one: "Mostrar {{count}} KPI que cumple el objetivo",
showOnTargetKpis_other: "Mostrar {{count}} KPI que cumplen el objetivo",
conditionEyebrow: "Condición",
conditionTitle: "¿Qué activos se están deteriorando?",
conditionSubtitle: "Derivado de inspecciones, reparaciones e historial de mantenimiento. Toque un activo para ver la evidencia completa.",
maintenanceEyebrow: "Mantenimiento",
maintenanceTitle: "¿Dónde se está retrasando el mantenimiento?",
maintenanceSubtitle: "El trabajo omitido se decidió; el no realizado, no. Se cuentan por separado.",
sitesEyebrow: "Sitios",
sitesTitle: "¿Qué sitio necesita atención?",
sitesSubtitle: "Salud por sitio, lo peor primero. Toque un sitio para centrar todo el panel en él.",
focusOnSiteLabel: "Centrarse en {{name}}. Salud {{score}} de 100.",
healthDetail: "Salud {{score}}/100 · {{atRisk}} de {{total}} en riesgo",
profileEyebrow: "Completitud del perfil",
profileTitle: "Activos a los que les faltan detalles de perfil",
profileSubtitle: "A estos registros de activos les faltan campos que usan las listas de verificación, los cálculos de riesgo y las recomendaciones.",
profileRowLabel: "{{needsData}} de {{total}} activos tienen perfiles incompletos. Abra la lista.",
profileRowTitle: "{{needsData}} de {{total}} perfiles de activos están incompletos",
profileWeak_one: "{{count}} activo tiene muy pocos detalles estructurados. Abra la lista para completar lo que falta.",
profileWeak_other: "{{count}} activos tienen muy pocos detalles estructurados. Abra la lista para completar lo que falta.",
profileOpenList: "Abre la lista para revisar y completar los campos que faltan.",
forecastEyebrow: "Previsión",
forecastTitle: "Lo que viene",
forecastSubtitle: "Previsto a partir de los vencimientos de los certificados, las programaciones y el ritmo de finalización: actúe antes de que se retrase.",
todayEyebrow: "Hoy",
topPrioritiesTitle: "Principales prioridades",
subtitleTechnician: "Sus próximas órdenes de trabajo, clasificadas por urgencia.",
subtitleManager: "Las 5 prioridades principales de tu ámbito, con su razonamiento y una acción recomendada.",
visibleOfTotal: "{{visible}} de {{total}}",
viewDetailsLabel: "Ver detalles",
workloadLabel: "Carga de trabajo",
reportingInsightLabel: "Información sobre informes",
clearedTitle: "Todo en orden.",
clearedBody: "No hay prioridades en este momento; mostraremos otras nuevas a medida que lleguen los datos.",
riskEyebrow: "Riesgo",
riskTitle: "¿Dónde se concentra el riesgo?",
riskSubtitle: "Exposición clasificada en toda la cartera, desglosada por criticidad y modo de falla.",
rankedCount_one: "{{count}} clasificado",
rankedCount_many: "{{count}} clasificados",
rankedCount_other: "{{count}} clasificados",
topExposuresEyebrow: "Mayores exposiciones por estado",
topExposuresTitle: "¿Qué activos tienen mayor exposición?",
nextAssetCaption: " Siguiente: {{name}} (estado {{score}}/100).",
riskHeatmapEyebrow: "Mapa de calor de riesgo",
riskHeatmapTitle: "Criticidad × tipo de activo",
riskHeatmapCaption: "Celdas más oscuras = puntuación de riesgo promedio más alta.",
riskByCriticalityEyebrow: "Riesgo por criticidad",
riskByCriticalityTitle: "¿Cómo se distribuye el riesgo por nivel de criticidad?",
riskByCriticalityCaption_one: "{{count}} activo en riesgo · Puntuación de riesgo de 50/100 o superior. Es posible que los activos por debajo de este umbral aún tengan trabajo vencido.",
riskByCriticalityCaption_other: "{{count}} activos en riesgo · Puntuación de riesgo de 50/100 o superior. Es posible que los activos por debajo de este umbral aún tengan trabajo vencido.",
topFailuresEyebrow: "Principales categorías de fallos",
topFailuresTitle: "¿Qué falla con más frecuencia?",
topFailuresCaption_one: "{{label}} encabeza la lista con {{count}} elemento marcado; investigue la causa raíz.",
topFailuresCaption_other: "{{label}} encabeza la lista con {{count}} elementos marcados; investigue la causa raíz.",
fewerAnalytics: "Menos análisis",
moreAnalytics: "Más análisis",
flowEyebrow: "Flujo",
flowTitle: "¿Cómo fluye el trabajo?",
flowSubtitle: "Forma del backlog y calidad de las inspecciones en los últimos 28 días.",
backlogEyebrow: "Composición del trabajo pendiente",
backlogTitle: "¿El trabajo pendiente está disminuyendo o aumentando?",
backlogCaption: "Hoy: {{overdue}} vencido · {{dueSoon}} vence pronto · {{upcoming}} próximamente.",
legendOverdue: "Vencido",
legendDueIn7d: "Vence en 7 d",
legendUpcoming: "Próximamente",
passRateEyebrow: "Tasa de inspecciones superadas",
passRateTitle: "¿Las inspecciones tienden a superarse o a fallar?",
passRateCaption: "Actualmente {{current}}% (frente a {{prev}}% hace 28 días - {{arrow}} {{delta}}pts).",
passRateEmpty: "Ejecute más inspecciones para completar la tendencia.",
noScheduledTitle: "Aún no hay elementos programados.",
noScheduledDescription: "Una vez que las inspecciones y las órdenes de trabajo fechadas estén disponibles, las tendencias de la carga de trabajo aparecerán aquí.",
teamsEyebrow: "Equipos y socios",
teamsTitle: "¿Cómo están rindiendo los equipos y contratistas?",
teamsSubtitle: "Las clasificaciones usan su ámbito actual ({{scope}}). Compare equipos cuando el ámbito sea Todos.",
compareTeamsTitle: "Compara equipos uno al lado del otro",
compareTeamsBody: "Estás viendo {{scope}}. Cambie a Todos para ver la carga de trabajo y el rendimiento clasificados en cada equipo.",
switchToAll: "Cambiar a Todos",
switchScopeAllLabel: "Cambia el ámbito a Todos para comparar equipos",
teamWorkloadEyebrow: "Carga de trabajo del equipo",
teamWorkloadTitle: "¿Qué equipos tienen más trabajo abierto?",
teamThroughputEyebrow: "Rendimiento del equipo",
teamThroughputTitle: "¿Quién cerró más trabajos en 28 días?",
cycleTimesShown: "Se muestran los tiempos de ciclo donde las órdenes de trabajo completadas tienen fechas de inicio y finalización.",
completedCountsCaption: "Número de completados en los últimos 28 días en su ámbito actual.",
openLabel_one: "{{count}} abierto",
openLabel_many: "{{count}} abiertos",
openLabel_other: "{{count}} abiertos",
overdueUnassigned: "{{overdue}} vencido · {{unassigned}} no asignado",
unassignedOnly_one: "{{count}} sin asignar",
unassignedOnly_many: "{{count}} sin asignar",
unassignedOnly_other: "{{count}} sin asignar",
doneLabel_one: "{{count}} completado",
doneLabel_many: "{{count}} completados",
doneLabel_other: "{{count}} completados",
avgCycleDays: "{{days}}d ciclo promedio",
stillOpen_one: "{{count}} aún abierto",
stillOpen_many: "{{count}} aún abiertos",
stillOpen_other: "{{count}} aún abiertos",
contractorPerformanceEyebrow: "Rendimiento de contratistas",
contractorPerformanceTitle: "¿Cómo rinden los contratistas comparados entre sí?",
overdueOnly_one: "{{count}} vencida",
overdueOnly_many: "{{count}} vencidas",
overdueOnly_other: "{{count}} vencidas",
doneWindow_one: "{{count}} completado (28 d)",
doneWindow_many: "{{count}} completados (28 d)",
doneWindow_other: "{{count}} completados (28 d)",
sentBack_one: "{{count}} devuelto",
sentBack_many: "{{count}} devueltos",
sentBack_other: "{{count}} devueltos",
avgCycle: "{{days}}d promedio",
toAnswer: "{{hours}}h para responder",
declinedOnly_one: "{{count}} rechazado",
declinedOnly_many: "{{count}} rechazados",
declinedOnly_other: "{{count}} rechazados",
techQualityEyebrow: "Calidad de técnico",
techQualityTitle: "¿Qué técnicos necesitan formación?",
techQualityCaption_one: "La puntuación combina la finalización a tiempo menos las reaperturas (0-100). Mediana de {{median}}/100 en {{count}} técnico.",
techQualityCaption_other: "La puntuación combina la finalización a tiempo menos las reaperturas (0-100). Mediana de {{median}}/100 en {{count}} técnicos.",
technicianFallback: "Técnico",
needsCoaching: "Necesita entrenamiento",
starPerformer: "Mejor desempeño",
onTrack: "Según lo previsto",
slippageEyebrow: "Retrasos",
slippageTitle: "¿Qué se está retrasando?",
slippageSubtitle: "Cobertura de inspección, lapsos de cumplimiento y brechas en su cadencia de inspección.",
coverageGapsEyebrow: "Brechas de cobertura",
coverageGapsTitle: "¿Qué activos necesitan una inspección ahora?",
coverageGapsCaptionKnown: "Elemento principal: {{label}} ({{days}}d desde la última inspección). Los elementos se ordenan por días × impacto operativo.",
coverageGapsCaptionNever: "Elemento principal: {{label}} (nunca inspeccionado). Los elementos se ordenan por días × impacto operativo.",
neverLabel: "Nunca",
complianceExpirationsEyebrow: "Vencimientos de cumplimiento",
complianceExpirationsTitle: "¿Qué vence en los próximos 90 días?",
complianceExpirationsCaption: "{{expired}} ya expiró, {{expiringSoon}} caducará dentro de 14 días.",
overdueDays: "{{days}}d vencido",
daysLeft: "Quedan {{days}} d",
inspectionDensityEyebrow: "Densidad de inspección",
inspectionDensityTitle: "¿Dónde están los huecos de frecuencia?",
inspectionDensityCaption_one: "{{count}} inspección en los últimos ~6 meses. Los tramos vacíos señalan huecos de cobertura.",
inspectionDensityCaption_many: "{{count}} inspecciones en los últimos ~6 meses. Los tramos vacíos señalan huecos de cobertura.",
inspectionDensityCaption_other: "{{count}} inspecciones en los últimos ~6 meses. Los tramos vacíos señalan huecos de cobertura.",
activityEyebrow: "Actividad",
activityTitle: "¿Qué acaba de pasar?",
activitySubtitle: "Las últimas inspecciones y actualizaciones de órdenes de trabajo en todo su alcance.",
whenToday: "hoy",
whenYesterday: "ayer",
whenDaysAgo: "hace {{days}} d",
severityFooterText: "La gravedad se muestra como impacto operativo (Bajo → Crítico), no como valores en dólares. AssetWRX no gestiona la cuenta de resultados: los datos de costes pertenecen a su ERP. Cuando conecte uno, se podrán añadir aquí cifras en dólares.",
askTitle: "Pregunte a AssetWRX",
askPlaceholderExecutive: "por ej. ¿Qué sitios costaron más el último trimestre?",
askPlaceholderTechnician: "por ej. ¿Qué órdenes de trabajo son mías hoy?",
askPlaceholderManager: "por ej. ¿Qué activos deben ser inspeccionados?",
askButton: "Pregunte",
pageSubtitle: "Vea dónde se acumula el trabajo, qué activos están en riesgo y quién está sobrecargado.",
greetingDanger_many: "{{count}} problemas necesitan atención hoy: el elemento principal es de alto riesgo.",
greetingTechnician_many: "Tiene {{count}} tareas en cola. Empiece por la tarjeta superior.",
greetingExecutive_many: "{{count}} elementos merecen un vistazo; primero, los más costosos.",
greetingTeam_many: "{{count}} prioridades para el equipo hoy.",
subtitleNeedAttention_many: "{{count}} necesitan atención · {{onTrack}} en el objetivo",
showOnTargetKpis_many: "Mostrar {{count}} KPI que cumplen el objetivo",
profileWeak_many: "{{count}} activos tienen muy pocos detalles estructurados. Abra la lista para completar lo que falta.",
riskByCriticalityCaption_many: "{{count}} activos en riesgo · Puntuación de riesgo de 50/100 o superior. Es posible que los activos por debajo de este umbral aún tengan trabajo vencido.",
topFailuresCaption_many: "{{label}} encabeza la lista con {{count}} elementos marcados; investigue la causa raíz.",
techQualityCaption_many: "La puntuación combina la finalización a tiempo menos las reaperturas (0-100). Mediana de {{median}}/100 en {{count}} técnicos.",
},
},
repairsApproved_many: "{{count}} reparaciones aprobadas",
title: "Actividad",
viewFeed: "Ver la actividad del equipo",
analyticsTitle: "Analítica",
recommendations: {
whyPrefix: "Por qué:",
failureTitle: "{{asset}} — Salud {{score}}/100",
impactRisk: "Riesgo",
actionOpenAsset: "Abrir activo",
actionScheduleAction: "Programar acción",
actionAssignTechnician: "Asignar técnico",
thinHistory: "Este activo tiene poco historial — registre una inspección para afianzar la puntuación.",
overdueTitle_one: "{{count}} orden de trabajo vencida en su ámbito",
overdueTitle_many: "{{count}} de órdenes de trabajo vencidas en su ámbito",
overdueTitle_other: "{{count}} órdenes de trabajo vencidas en su ámbito",
overdueWhy: "Por qué: las fechas de vencimiento pasaron sin que se completara el trabajo — el trabajo pendiente está creciendo.",
impactOldest: "La más antigua",
oldestValue_one: "{{count}} d de retraso",
oldestValue_many: "{{count}} d de retraso",
oldestValue_other: "{{count}} d de retraso",
actionTriageBacklog: "Hacer el triaje del trabajo pendiente",
complianceTitle_one: "{{count}} elemento de cumplimiento caduca en 30 días",
complianceTitle_many: "{{count}} de elementos de cumplimiento caducan en 30 días",
complianceTitle_other: "{{count}} elementos de cumplimiento caducan en 30 días",
complianceWhy: "Por qué: las certificaciones y las inspecciones caducan si no se actúa.",
impactAtRisk: "En riesgo",
assetsCount_one: "{{count}} activo",
assetsCount_many: "{{count}} de activos",
assetsCount_other: "{{count}} activos",
actionOpenCompliance: "Abrir cumplimiento",
trainingTitle_one: "{{count}} técnico con reaperturas repetidas",
trainingTitle_many: "{{count}} de técnicos con reaperturas repetidas",
trainingTitle_other: "{{count}} técnicos con reaperturas repetidas",
trainingWhy: "Por qué: la misma clase de activo se reabrió varias veces en 90 d — probablemente falte formación.",
impactRecurringRework: "Retrabajo recurrente",
reopensCount_one: "{{count}} reapertura",
reopensCount_many: "{{count}} de reaperturas",
reopensCount_other: "{{count}} reaperturas",
actionViewContacts: "Ver contactos",
inspectionDueTitle_one: "{{count}} activo necesita inspección",
inspectionDueTitle_many: "{{count}} de activos necesitan inspección",
inspectionDueTitle_other: "{{count}} activos necesitan inspección",
inspectionDueWhy: "Por qué: no se ha completado ninguna inspección en los últimos 90 días.",
impactCoverageGap: "Hueco de cobertura",
actionScheduleInspections: "Programar inspecciones",
approvalsInspections_one: "{{count}} inspección pendiente de aprobación",
approvalsInspections_many: "{{count}} de inspecciones pendientes de aprobación",
approvalsInspections_other: "{{count}} inspecciones pendientes de aprobación",
approvalsJobs_one: "{{count}} orden de trabajo pendiente de verificación",
approvalsJobs_many: "{{count}} de órdenes de trabajo pendientes de verificación",
approvalsJobs_other: "{{count}} órdenes de trabajo pendientes de verificación",
approvalsTitle_one: "{{count}} decisión pendiente de usted",
approvalsTitle_many: "{{count}} de decisiones pendientes de usted",
approvalsTitle_other: "{{count}} decisiones pendientes de usted",
approvalsWhyOne: "Por qué: {{part}}. El trabajo sigue abierto hasta que alguien lo apruebe.",
approvalsWhyBoth: "Por qué: {{first}} y {{second}}. El trabajo sigue abierto hasta que alguien lo apruebe.",
impactWaiting: "En espera",
actionReviewApprove: "Revisar y aprobar",
jobFallback: "Orden de trabajo",
nextJobDue: "Por qué: vence el {{date}}.",
nextJobAssigned: "Por qué: se le ha asignado a usted.",
impactUrgency: "Urgencia",
actionOpenJob: "Abrir orden de trabajo",
},
insightQuality: {
confidenceHigh: "Confianza alta",
confidenceMedium: "Confianza media",
confidenceLow: "Confianza baja",
notEnoughHistory: "{{label}} · no hay suficiente historial reciente",
basedOnOne: "{{label}} · a partir de {{part}}",
basedOnBoth: "{{label}} · a partir de {{first}} y {{second}}",
inspections_one: "{{count}} inspección",
inspections_many: "{{count}} de inspecciones",
inspections_other: "{{count}} inspecciones",
jobs_one: "{{count}} orden de trabajo",
jobs_many: "{{count}} de órdenes de trabajo",
jobs_other: "{{count}} órdenes de trabajo",
noInspectionsInScope: "No hay inspecciones en el ámbito",
limitedJobHistory: "Historial de órdenes de trabajo limitado",
noCompletedInspections: "No hay inspecciones completadas",
noInspectionInDays_one: "Sin inspecciones desde hace {{count}} día",
noInspectionInDays_many: "Sin inspecciones desde hace {{count}} de días",
noInspectionInDays_other: "Sin inspecciones desde hace {{count}} días",
noInspectionHistory: "Sin historial de inspecciones",
assetMetadataIncomplete: "Metadatos del activo incompletos",
noRecentTimestamps: "Sin marcas de tiempo de actividad reciente",
dataGapNoInspection_one: "Faltan datos: sin inspecciones desde hace {{count}} día",
dataGapNoInspection_many: "Faltan datos: sin inspecciones desde hace {{count}} de días",
dataGapNoInspection_other: "Faltan datos: sin inspecciones desde hace {{count}} días",
dataGapLastActivity_one: "Faltan datos: última actividad hace {{count}} día",
dataGapLastActivity_many: "Faltan datos: última actividad hace {{count}} de días",
dataGapLastActivity_other: "Faltan datos: última actividad hace {{count}} días",
limitedData: "Datos limitados: tómelo solo como orientación",
},
activityTimeline: {
inspectionCompleted: "Inspección completada",
inspectionInProgress: "Inspección en curso",
itemsFlagged_one: "{{count}} elemento marcado",
itemsFlagged_many: "{{count}} de elementos marcados",
itemsFlagged_other: "{{count}} elementos marcados",
allPassing: "Todos los elementos superados",
jobUpdated: "Orden de trabajo actualizada",
},
portfolioNarrative: {
flat: "La salud de la cartera es de {{score}}/100 — las tendencias aparecerán a medida que se acumulen datos.",
improved_one: "Su cartera está más sana este mes — la salud operativa subió {{count}} punto hasta {{score}}/100{{driver}}.",
improved_many: "Su cartera está más sana este mes — la salud operativa subió {{count}} de puntos hasta {{score}}/100{{driver}}.",
improved_other: "Su cartera está más sana este mes — la salud operativa subió {{count}} puntos hasta {{score}}/100{{driver}}.",
improvedDriver_one: ", ya que {{count}} activo salió de la banda de riesgo",
improvedDriver_many: ", ya que {{count}} de activos salieron de la banda de riesgo",
improvedDriver_other: ", ya que {{count}} activos salieron de la banda de riesgo",
slipped_one: "La salud de la cartera bajó {{count}} punto hasta {{score}}/100 este mes.",
slipped_many: "La salud de la cartera bajó {{count}} de puntos hasta {{score}}/100 este mes.",
slipped_other: "La salud de la cartera bajó {{count}} puntos hasta {{score}}/100 este mes.",
steady: "La salud de la cartera se mantuvo estable en {{score}}/100 este mes.",
concern: " Algo a vigilar: {{concern}}.",
},
partnersCaptions: {
teamEmpty: "Asigne órdenes de trabajo a equipos para comparar la carga de trabajo y el rendimiento.",
teamSingle: "{{team}}: {{open}} abiertas, {{completed}} completadas en {{days}} d.",
teamOverdue: "{{worst}} tiene más trabajo vencido ({{overdue}}); {{leader}} tiene la mayor cola de trabajo abierto ({{open}}).",
teamThroughput: "{{leader}} tiene la mayor cola de trabajo abierto; {{top}} cerró más en {{days}} d ({{completed}}).",
teamLeader_one: "{{leader}} tiene la mayor cola de trabajo abierto ({{count}} orden de trabajo).",
teamLeader_many: "{{leader}} tiene la mayor cola de trabajo abierto ({{count}} de órdenes de trabajo).",
teamLeader_other: "{{leader}} tiene la mayor cola de trabajo abierto ({{count}} órdenes de trabajo).",
contractorEmpty: "Asigne órdenes de trabajo realizadas por contratistas para ver aquí su rendimiento.",
contractorOverdue_one: "{{worst}} tiene {{count}} orden de trabajo vencida; {{leader}} tiene la mayor carga activa ({{open}} abiertas).",
contractorOverdue_many: "{{worst}} tiene {{count}} de órdenes de trabajo vencidas; {{leader}} tiene la mayor carga activa ({{open}} abiertas).",
contractorOverdue_other: "{{worst}} tiene {{count}} órdenes de trabajo vencidas; {{leader}} tiene la mayor carga activa ({{open}} abiertas).",
contractorRework_one: "A {{name}} se le devolvió {{count}} orden de trabajo; {{leader}} encabeza las asignaciones abiertas ({{open}}).",
contractorRework_many: "A {{name}} se le devolvieron {{count}} de órdenes de trabajo; {{leader}} encabeza las asignaciones abiertas ({{open}}).",
contractorRework_other: "A {{name}} se le devolvieron {{count}} órdenes de trabajo; {{leader}} encabeza las asignaciones abiertas ({{open}}).",
contractorCompleted_one: "{{name}} completó {{count}} orden de trabajo en {{days}} d; {{leader}} tiene {{open}} abiertas.",
contractorCompleted_many: "{{name}} completó {{count}} de órdenes de trabajo en {{days}} d; {{leader}} tiene {{open}} abiertas.",
contractorCompleted_other: "{{name}} completó {{count}} órdenes de trabajo en {{days}} d; {{leader}} tiene {{open}} abiertas.",
contractorLeader: "{{leader}} tiene la mayor carga de trabajo de contratistas ({{open}} abiertas).",
},
siteRisk: {
whyTwoDrivers: "Salud operativa {{score}}/100 — riesgo debido a {{first}} y a {{second}}.",
whyOneDriver: "Salud operativa {{score}}/100 — riesgo debido a {{driver}}.",
whyExposure: "Salud operativa {{score}}/100 — exposición operativa {{risk}}/100.",
subLabelExposure: "Exposición operativa {{risk}}/100",
},
rootCause: {
assetCount_one: "{{count}} activo",
assetCount_many: "{{count}} de activos",
assetCount_other: "{{count}} activos",
dayCount_one: "{{count}} día",
dayCount_many: "{{count}} de días",
dayCount_other: "{{count}} días",
jobCount_one: "{{count}} orden de trabajo",
jobCount_many: "{{count}} de órdenes de trabajo",
jobCount_other: "{{count}} órdenes de trabajo",
categoryJobs_one: "{{count}} orden de trabajo de {{category}}",
categoryJobs_many: "{{count}} de órdenes de trabajo de {{category}}",
categoryJobs_other: "{{count}} órdenes de trabajo de {{category}}",
itemFailures_one: "{{count}} fallo en «{{label}}»",
itemFailures_many: "{{count}} de fallos en «{{label}}»",
itemFailures_other: "{{count}} fallos en «{{label}}»",
categoryIssues_one: "{{count}} problema de {{category}}",
categoryIssues_many: "{{count}} de problemas de {{category}}",
categoryIssues_other: "{{count}} problemas de {{category}}",
jobReopens_one: "{{count}} reapertura de orden de trabajo",
jobReopens_many: "{{count}} de reaperturas de órdenes de trabajo",
jobReopens_other: "{{count}} reaperturas de órdenes de trabajo",
reopenCount_one: "{{count}} reapertura",
reopenCount_many: "{{count}} de reaperturas",
reopenCount_other: "{{count}} reaperturas",
likelyDriver: "Causa probable: {{driver}}",
titleJobCategory: "Patrón recurrente: {{jobs}} entre {{assets}} en {{days}}",
driverJobCategory: "la categoría de trabajo {{category}} se repite en activos similares.",
driverJobCategoryScope: "Puede que el mismo desencadenante operativo o el alcance de la lista de verificación no se estén abordando lo suficiente.",
counterJobCategory: "El mantenimiento planificado puede repetir legítimamente la misma categoría — confirme las programaciones.",
actionJobCategory: "Revise el alcance del trabajo de {{category}} y el método de reparación, e inspeccione los activos relacionados.",
titleInspectionItem: "Patrón recurrente: {{failures}} entre {{assets}} en {{days}}{{site}}",
siteSame: " en el mismo sitio",
siteMultiple: " en varios sitios",
driverInspectionItem: "el mismo elemento de inspección falla repetidamente ({{label}}).",
driverInspectionItemScope: "El alcance de la lista de verificación, las condiciones ambientales o la verificación de la reparación de este elemento.",
counterInspectionItem: "Las campañas de inspección estacionales o puntuales pueden concentrar fallos de forma temporal.",
actionInspectionItem: "Revise el elemento de la lista de verificación «{{label}}» e inspeccione los activos relacionados del sitio.",
titleAssetRepeat: "Patrón recurrente: {{asset}} vuelve a fallar tras la reparación ({{jobs}} en {{days}})",
driverAssetRepeat: "la misma categoría de fallo se repite tras la reparación.",
driverAssetRepeatCause: "Puede que no se hayan resuelto el método de reparación, las piezas o el defecto de origen.",
counterAssetRepeat: "El trabajo de seguimiento puede ser una verificación planificada — confirme el propósito de la orden de trabajo.",
actionAssetRepeat: "Revise el método de reparación e inspeccione los activos relacionados.",
latestRepair: "Última reparación",
postRepairInspection: "Inspección posterior a la reparación con fallos",
titleFailureType: "Patrón recurrente: {{issues}} en activos de tipo {{assetType}} ({{assets}}, {{days}})",
driverFailureType: "los fallos de {{category}} se concentran en el tipo de activo {{assetType}}.",
counterFailureType: "Puede que haya pocos activos de este tipo — confirme que la muestra es representativa.",
actionFailureType: "Revise los estándares de {{category}} para los activos de tipo {{assetType}} y los elementos relacionados de la lista de verificación.",
titleTechReopen: "Patrón recurrente: {{name}} acumula {{reopens}} en {{days}}",
driverTechReopen_one: "{{name}} tiene reaperturas repetidas en {{count}} categoría.",
driverTechReopen_many: "{{name}} tiene reaperturas repetidas en {{count}} de categorías.",
driverTechReopen_other: "{{name}} tiene reaperturas repetidas en {{count}} categorías.",
driverTechReopenCause: "Puede que haya que revisar los criterios de cierre, las piezas o la calidad del traspaso.",
counterTechReopen: "Las reaperturas pueden deberse a llamadas de clientes que no tienen que ver con la competencia del técnico.",
actionTechReopen: "Revise las órdenes de trabajo reabiertas con {{name}} y verifique los criterios de cierre.",
titleVendorReopen: "Patrón recurrente: el proveedor {{name}} acumula {{reopens}} en {{days}}",
driverVendor: "el contratista {{name}} está vinculado a reaperturas repetidas.",
counterVendor: "Los picos de carga de trabajo del proveedor pueden coincidir con reaperturas sin que haya problemas de calidad.",
actionVendor: "Revise el rendimiento y el alcance del trabajo del contratista {{name}}.",
titlePart: "Patrón recurrente: {{jobs}} con «{{part}}» entre {{assets}} en {{days}}",
driverPart: "la pieza o categoría «{{part}}» aparece en órdenes de trabajo repetidas.",
counterPart: "La reposición de existencias o los kits de mantenimiento planificado pueden repetir legítimamente la misma pieza en varios activos.",
actionPart: "Revise la calidad y el ajuste de «{{part}}» y el alcance de su mantenimiento planificado.",
assetFallback: "Activo",
jobFallback: "Orden de trabajo",
contractorFallback: "Contratista",
checklistItemFallback: "Elemento de la lista de verificación",
uncategorised: "Sin categoría",
impactRecurrence: "Recurrencia",
impactRecurrenceValue_one: "{{events}} en {{count}} día",
impactRecurrenceValue_many: "{{events}} en {{count}} de días",
impactRecurrenceValue_other: "{{events}} en {{count}} días",
reviewPattern: "Revisar patrón",
viewJobs: "Ver órdenes de trabajo",
},
actionPlans: {
reviewData: "Revisar datos",
reviewDataDetail: "Confirme el historial de inspecciones y órdenes de trabajo antes de comprometer recursos.",
withinDays_one: "En un plazo de {{count}} día",
withinDays_many: "En un plazo de {{count}} de días",
withinDays_other: "En un plazo de {{count}} días",
scheduleWithin_one: "Programar una inspección en un plazo de {{count}} día",
scheduleWithin_many: "Programar una inspección en un plazo de {{count}} de días",
scheduleWithin_other: "Programar una inspección en un plazo de {{count}} días",
scheduleWithinDetail: "Verifique el estado y registre pruebas en el sitio.",
openAssetRecord: "Abrir la ficha del activo",
openAssetRecordDetail: "Revise el historial, las órdenes de trabajo vinculadas y los resultados de la última inspección.",
scheduleInspection: "Programar inspección",
benefitDowntime: "Reducir el riesgo de inactividad",
benefitCatchDefects: "Detectar defectos antes de que haya una avería",
effortFailureUrgent: "Bajo — asignar un técnico e inspeccionar el estado de la junta",
effortFailure: "Bajo — asignar un responsable y confirmar el alcance de la lista de verificación",
triageOverdue: "Hacer hoy el triaje de las órdenes de trabajo vencidas",
triageOverdueDetail: "Vuelva a priorizar, reasigne o actualice las fechas de vencimiento.",
escalateBlockers: "Escalar los bloqueos",
escalateBlockersDetail: "Identifique las órdenes de trabajo a la espera de piezas, acceso o aprobaciones.",
today: "Hoy",
benefitSla: "Recuperar el SLA y frenar el crecimiento del trabajo pendiente",
effortOverdue: "Medio — revisar las asignaciones y las fechas de vencimiento de todo el grupo",
renewCertificate: "Renovar el certificado antes de que caduque",
renewCertificateDetail: "Reserve la certificación o la inspección de cumplimiento antes de que venza.",
openCompliance: "Abrir el área de cumplimiento",
openComplianceDetail: "Confirme los responsables y las fechas de renovación de cada activo.",
beforeExpiry: "Antes de que caduque (30 días)",
benefitCompliance: "Evitar incumplimientos y riesgos en las auditorías",
effortCompliance: "Bajo — confirmar el responsable de la renovación y las fechas de vencimiento",
reviewReopened: "Revisar las órdenes de trabajo reabiertas y asignar formación",
reviewReopenedDetail: "Repase los fallos repetidos con el técnico en las categorías afectadas.",
viewContacts: "Ver contactos",
viewContactsDetail: "Compruebe la carga de trabajo y los emparejamientos para el seguimiento correctivo.",
thisWeek: "Esta semana",
benefitRework: "Reducir el retrabajo repetido y mejorar la tasa de resolución a la primera",
effortTraining: "Medio — formar sobre los patrones por categoría y verificar los criterios de cierre",
createJob: "Crear orden de trabajo",
scheduleOverdue: "Programar las inspecciones atrasadas de los activos",
scheduleOverdueDetail: "Cierre el hueco de cobertura de 90 días con listas de verificación basadas en listas de control.",
openInspections: "Abrir el área de inspecciones",
openInspectionsDetail: "Programe en lote o empiece desde el área de inspecciones.",
benefitCoverage: "Recuperar la cobertura de inspecciones y la visibilidad del riesgo",
effortInspection: "Bajo — elegir una lista de control y asignar inspectores",
reviewPattern: "Revisar el patrón recurrente",
inspectRelated: "Inspeccionar los activos relacionados",
inspectRelatedDetail: "Recorra los activos del grupo y verifique el método de reparación, las piezas y el alcance de la lista de verificación.",
reviewSupporting: "Revisar las órdenes de trabajo e inspecciones de respaldo",
reviewSupportingDetail: "Confirme las pruebas antes de cambiar los estándares.",
patternWindow: "Patrón · {{value}}",
benefitCycles: "Romper los ciclos de fallos repetidos y reducir el retrabajo",
effortRootCause: "Medio — cruzar órdenes de trabajo, inspecciones e historial de reparaciones",
viewJobs: "Ver órdenes de trabajo",
startAssignedJob: "Abrir e iniciar la orden de trabajo asignada",
dueWindow: "Vence · {{value}}",
whenDue: "Cuando venza",
benefitOnTrack: "Mantener al día el trabajo asignado",
effortNextJob: "Bajo — abrir la orden de trabajo y publicar la primera actualización",
openJob: "Abrir orden de trabajo",
},
};
